import { render, staticRenderFns } from "./resourceSupplierManage.vue?vue&type=template&id=07cf9064&scoped=true"
import script from "./resourceSupplierManage.vue?vue&type=script&lang=js"
export * from "./resourceSupplierManage.vue?vue&type=script&lang=js"
import style0 from "./resourceSupplierManage.vue?vue&type=style&index=0&id=07cf9064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf9064",
  null
  
)

export default component.exports